module.exports = "/_next/static/images/bb-3fb12ea551927c657572d7b0a8132a2d.svg";